import styled from 'styled-components';

export const BackgroundContainer = styled.div`
  width: 100vw;
  height: ${props => props.height};
  opacity: ${props => (props.show ? 1 : 0)};
  display: ${props => (props.show ? 'flex' : 'none')};
  transition: opacity 0.3s ease-in-out, display 0s 1s linear;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  background: ${props => props.theme['app-background-color']};
  -webkit-flex-direction: column;
  flex-direction: column;
`;

export const Logo = styled.div`
  height: 600px;
  width: 600px;
  position: absolute;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;
  display: inline-block;
  path {
    fill: ${props => props.theme['app-background-color']};
  }
`;
